import BadgeIcon from "@mui/icons-material/Badge";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import SearchIcon from "@mui/icons-material/Search";
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import { useNavigate,useLocation } from "react-router-dom";
import {
  Box,
  Card,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useEffect, useState } from "react"; 
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";
import CustomCardList from "../components/Cards";
import ConfirmationPopup from "../components/ConfirmationPopup";
import PageLoader from "../components/Loader";
import CustomTable from "../components/Table";
import { useToast } from "../components/Toast";
import CustomButton from "../components/Button";
import TestTypeSelect, { getTestTypeLabel } from "../components/TestTypeSelect";
import FindingsCell from "../components/FindingsCell";
const UserTests = () => {
  const auth = localStorage.getItem("token");
  const Toast = useToast();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const locationCheck = useLocation();
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1); // Page starts from 1
  const [rowsPerPage, setRowsPerPage] = useState(10); // Rows per page
  const { uid, mobile, name, source,doctor, testType: initialTestType } = locationCheck.state || {};
  const [testType, setTestType] = useState(initialTestType || "");
  const isMobile = useIsMobile();
  const theme = useTheme();
  const [openPopup, setOpenPopup] = useState(false);
  const [id, setId] = useState(); 
  const [isLoading, setIsLoading] = useState(false);
  const [tests, setTests] = useState([]); 
  const handlePageChange = (event, newPage) => {
    setPage(newPage + 1); // Set the new page
  };
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10)); // Update rows per page when changed
    setPage(1); // Reset to page 1 when rows per page change
  };
  const handleSearch = async (event) => {
    const keyword = event.target.value.toLowerCase();
    setSearchQuery(keyword);
  
    // Reset to page 0 on new search
    setPage(0);
  
    if (!keyword.trim()) {
      getTests(0, rowsPerPage);
    } else {
      getTests(0, rowsPerPage, keyword);
    }
  };
  
  const getTests = async (page, limit, keyword='') => {
    setIsLoading(true);
    try {
      const tests = await apiService.fetchUserTests(uid, auth, page, limit, keyword, testType);
      setTests(
        tests.data.tests.tests.map((test) => ({
          ...test,
          // Soft tissue findings live in softTissueDetections, not detections
          hasDetections:
            (test.detections?.length || 0) + (test.softTissueDetections?.length || 0) > 0,
        }))
      );
      setTotalCount(tests.data.tests.total);
     
      setIsLoading(false);
    } catch (error) {
      //Toast.error("Error while Fetching");
    } finally {
      setIsLoading(false);
    }
  };
 
  const handleOpenPopup = (testId) => {
    setOpenPopup(true);
    setId(testId);
  };
  const handleConfirm = async (testId) => {
    setOpenPopup(false);

    try {
      setIsLoading(true);

      const result = await apiService.deleteTest(auth, uid, testId); 
      setIsLoading(false);
      Toast.success("Test Deleted successfully!");
      window.location.reload();
    } catch (error) {
      console.error(
        "Error during upload:",
        error.response?.data || error.message
      );
      Toast.error("Test Delete failed. Please try again.");
    }
  };
  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  useEffect(() => {
    getTests(page, rowsPerPage, searchQuery);
  }, [page, rowsPerPage, searchQuery, testType]);
  
  const Source = {
    other: "Other",
    App: "App",
    Kiosk: "Kiosk",
    WhatsApp: "WhatsApp",
    Engage: "Engage",
    Helpline: "Helpline",
  };
  const getStatusStyles = (status) => {
    switch (status) {
      case Source.other:
        return { color: "red" };
      case Source.App:
        return { color: "#002446" };
      case Source.Kiosk:
        return { color: "#874EF6" };
      case Source.WhatsApp:
        return { color: "#green" };
      case Source.Engage:
        return { color: "#2544a1" };
      case Source.Helpline:
        return { color: "#b06b9d" };
      default:
        return { color: "#888" };
    }
  };
  const fields = [
    { label: "date", key: "date" },
    { label: "tid", key: "tid" },
  ];
  const columns = [
    {
      field: "date",
      headerName: "date",
      align: "center",
      renderCell: (params) => {
        const rawDate = params;
        if (!rawDate) return "--";
    
        const date = new Date(rawDate);
        const formattedDate = date.toLocaleString('en-IN', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
    
        return (
          <span style={{ fontSize: "1rem", fontWeight: "500" }}>
            {formattedDate}
          </span>
        );
      },
    },
    {
      field: "tid",
      headerName: "test Id",
      align: "center",
    },
    {
      field: "testType",
      headerName: "Scan type",
      align: "center",
      renderCell: (value) => getTestTypeLabel(value),
    },
    {
      field: "hasDetections",
      headerName: "Detection",
      align: "center",
      renderCell: (hasDetections) => {
        const isEmpty = !hasDetections;
    
        return (
          <span style={{      color: isEmpty ? "red" : "green",}}>
            {isEmpty ? "Empty Test" : "Valid"}
          </span>
        );
      },
    },
    {
      field: "findingsCount",
      headerName: "Findings",
      align: "center",
      renderCell: (count, row) => <FindingsCell count={count} names={row.findingNames} />,
    },
    {
      field: "kioskName",
      headerName: "kiosk",
      align: "center",
    },
    {
      field: "source",
      headerName: "Test Mode",
      align: "center",
      renderCell: (value) => {
        const status = value; // Get the value from the params object
        const styles = getStatusStyles(status); // Get the styles based on the status

        return (
          <span
            style={{
              fontWeight: "bold",
              fontSize: "1rem",
              ...styles,
            }}
          >
            {value}
          </span>
        );
      },
    },
    {
      field: "tid",
      headerName: "Delete Test ",
      align: "center",
      renderCell: (params) => {
        const testId = params;
        return (
          <DeleteIcon
            color="primary"
            style={{ cursor: "pointer" }}
            onClick={() => handleOpenPopup(testId)}
          />
        );
      },
    },
   
  ];

  const detailsClick = (row) => {
    navigate(`/dashboard/user/test/${row.tid}`, {
      state: {
        tid: row.tid,
        detections: row.detections,
        softTissueDetections: row.softTissueDetections,
        testType: row.testType,
        uid,
        name,
        kioskId: row.kioskId,
        doctor,
      },
    });
  };
  return (
    <Paper sx={{ padding: 2 }}>
      <Card
        elevation={3}
        sx={{
          borderRadius: 3,
          padding: 3,
          mb: 4,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        }}
      >
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Patient Details
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={4}>
          <Grid item xs={12} sm={3}>
            <Box display="flex" alignItems="top" gap={1}>
              <BadgeIcon color="primary" />
              <Box>
                <Typography variant="body2" color="primary">
                  User ID
                </Typography>
                <Typography color="text.primary" variant="subtitle1">
                  {uid || "N/A"}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Box display="flex" alignItems="top" gap={1}>
              <PersonIcon color="primary" />
              <Box>
                <Typography variant="body2" color="primary">
                  Name
                </Typography>
                <Typography color="text.primary" variant="subtitle1">
                  {name || "N/A"}
                </Typography>
               
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box display="flex" alignItems="top" gap={1}>
              <LocalHospitalIcon color="primary" />
              <Box>
                <Typography variant="body2" color="primary">
                  Associate Doctor(client)
                </Typography>
                <Typography color="text.primary" variant="subtitle1">
                  {doctor || "N/A"}
                </Typography>
              </Box>
            </Box>
          </Grid>
         
          <Grid item xs={12} sm={3}>
            <Box display="flex" alignItems="top" gap={1}>
              <PhoneIphoneIcon color="primary" />
              <Box>
                <Typography variant="body2" color="primary">
                  Mobile
                </Typography>
                <Typography color="text.primary" variant="subtitle1">
                  {mobile || "N/A"}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Card>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          marginBottom: 2,
        }}
      >
        <Box mt={3}>
          <TestTypeSelect
            value={testType}
            onChange={(value) => {
              setTestType(value);
              setPage(1);
            }}
          />
        </Box>
        <TextField
          label="Search"
          variant="outlined"
          value={searchQuery}
          onChange={handleSearch}
          fullWidth
          sx={{ marginBottom: 2, marginTop: 3 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
      {isMobile ? (
        // Card layout for mobile
        <CustomCardList
          page={page - 1} // Adjust for zero-based indexing for `CustomTable`
          rowsPerPage={rowsPerPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          fields={fields}
          data={tests}
          onCardClick={(row) => detailsClick(row)}
        />
      ) : (
        <CustomTable
          columns={columns}
          data={tests}
          // onRowClick={(row) =>
          //   detailsClick(
          //     row.id,
          //     row.name,
          //     row.clinicName,
          //     row.location,
          //     row.code,
          //     row.status,
          //     row.shipStatus
          //   )
          // }
          actions={[
            {
              Component: CustomButton,
              props: { text: "Details", width: "90px", height: "40px" },
              onClick: (row) => detailsClick(row),
            },
          ]}
          page={page - 1} // Adjust for zero-based indexing for `CustomTable`
          rowsPerPage={rowsPerPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}

      {isLoading && <PageLoader />}
      <ConfirmationPopup
        open={openPopup}
        onClose={handleClosePopup}
        onConfirm={() => handleConfirm(id)}
      />
    </Paper>
  );
};

export default UserTests;
